/**
 * ThirdPartyHelper
 * params
 * -iFrame Html
 */

import tplIframe from './thirdPartyHelper.html';
import { stringToHTML } from 'util';
import { ALLOWED_PLUGINS } from 'util';

Genesys('registerPlugin', 'ThirdPartyHelper', (ThirdPartyHelper) => {
  const $$ = ThirdPartyHelper.data;
  const aThirdPartyPlugins = ['NewRelic']; // plugins that doesn't depend on config

  $$('iFrameLoaded', false);

  /** Disable eslint unencoded input used in HTML context. We don't inject external html here. */
  let iframeHtml = tplIframe; // eslint-disable-line

  function configurePlugins(config) {
    // if (!config) return; // Ranjith: No need of config availability to load third party plugins like NewRelic. These need to be load upfront to publish error in case of config failed to load, etc.

    // Pass the configuration to all expected third-party plugins
    aThirdPartyPlugins.forEach((pluginName) => {
      ThirdPartyHelper.subscribe(`${pluginName}.ready`, () => {
        ThirdPartyHelper.command(`${pluginName}.configure`, config);
      });
    });
  }

  ThirdPartyHelper.subscribe('ServiceDiscovery.ready', () => {
    // [WEBMESS-16] Get the version from browser global if present. Remove this before releasing
    const sVersion = window._webMessVersion ? `/${window._webMessVersion}` : '';

    // Production:
    const sThirdPartyHelperHTML = `${ThirdPartyHelper.data(
      'ServiceDiscovery.uris.staticAssets'
    )}/messenger${sVersion}/thirdparty-plugins.html`;

    /** False positive - disable eslint HTML passed into function rule. We don't inject external html here. */
    iframeHtml = iframeHtml.replace(
      '{genesys-thirdparty-url}',
      sThirdPartyHelperHTML
    ); // eslint-disable-line

    // After service discovery is done, mark as ready
    ThirdPartyHelper.ready();
  });

  ThirdPartyHelper.registerCommand('open', (e) => {
    if (e && ALLOWED_PLUGINS.includes(e.commander)) {
      // eslint-disable-line
      if ($$('iFrameLoaded')) {
        e.reject('ThirdPartyHelper iframe is already open');
      } else {
        // const deploymentConfig =
        //   ThirdPartyHelper.data('GenesysJS.deploymentConfig') || {};
        // const snippetConfig =
        //   ThirdPartyHelper.data('GenesysJS.snippetConfig') || {};

        // inject iframe into the parent page
        document.body.appendChild(stringToHTML(iframeHtml));

        $$('iFrameLoaded', true);
        ThirdPartyHelper.republish('iFrameLoaded');

        configurePlugins(e.data);
        e.resolve();
      }
    } else {
      e.reject('Unauthorized access! Only Genesys plugins are allowed to interact with this plugin.');
    }
  });

  ThirdPartyHelper.registerCommand('update', e => {
    const { messenger } = e.data || {};
    const { preview } = messenger || {};


    const deploymentConfig =
        ThirdPartyHelper.data('GenesysJS.deploymentConfig') || {};
    const snippetConfig =
        ThirdPartyHelper.data('GenesysJS.snippetConfig') || {};

    // update/reconfigure Messenger when it is not running in preview mode
    if (!preview) { // why block it like this? So preview can only be enabled, not disabled? why?
      ThirdPartyHelper.publish('update', {
        snippetConfig,
        deploymentConfig,

        // TODO: remove once the plugin has been updated to use deploymentConfig/snippetConfig
        deploymentId: snippetConfig.deploymentId,
        config: deploymentConfig.messenger,
      });
    }

    e.resolve();
  });
});
